
const DRUH_POZEMKU = [
    {code: 0, title: 'neuvedeno'},
    {code: 2, title: 'orná půda'},
    {code: 3, title: 'chmelnice'},
    {code: 4, title: 'vinice'},
    {code: 5, title: 'zahrada'},
    {code: 6, title: 'ovocný sad'},
    {code: 7, title: 'trvalý travní porost'},
    {code: 10, title: 'lesní pozemek'},
    {code: 11, title: 'vodní plocha'},
    {code: 13, title: 'zastavěná plocha a nádvoří'},
    {code: 14, title: 'ostatní plocha'}
];

function getDruhPozemku(code) {
    return DRUH_POZEMKU.reduce((previous, current) => {
        return (current.code === code)
            ? current
            : previous;
    }, null);
}

function getDruhPozemkuTitle(code) {
    const druhPozemku = getDruhPozemku(code);
    return (druhPozemku) ? druhPozemku.title : `druh pozemku ${code}`;
}

module.exports = {
    DRUH_POZEMKU,
    getDruhPozemku,
    getDruhPozemkuTitle
};
